@import 'src/global/media_queries'
@import './../afs-navbar-common'

header
    --nav-height-gradient: var(--nav-height)
    height: var(--nav-height-gradient)

    .fixed-navbar
        height: var(--nav-height-gradient)
        
        .logobox
            height: var(--logo-height)

            @include media(">=tablet", "height>=720px")
                height: var(--logo-height-desktop)

        .right-container
            .ascend-logobox
                height: calc(var(--afs-logo-height) * 2)

                @include media(">=tablet", "height>=720px")
                    height: var(--afs-logo-height)

    @include media(">=tablet", "height>=720px")
        --nav-height-gradient: calc(var(--nav-height) * 2)